import { HisWidgetBase } from './his-widget-base';

export class HisSearchCriteriagroup {

    /** Excluding */
    notInCriteriaGroup: boolean;
    widgets: HisWidgetBase<any>[];

    constructor() {
        this.notInCriteriaGroup = false;
        this.widgets = [];
    }

    equals(other: HisSearchCriteriagroup): boolean {
        if (other === this) {
            return true;
        }

        if (
            other &&
            other.constructor === this.constructor &&
            other.notInCriteriaGroup === this.notInCriteriaGroup &&
            this.areArraysEqual(other.widgets, this.widgets)
        ) {
            return true;
        }

        return false;
    }

    private areArraysEqual<T>(arr1: T[], arr2: T[]): boolean {
        if (arr1.length !== arr2.length) {
            return false;
        }

        for (let i = 0; i < arr1.length; i++) {
            if (arr1[i] !== arr2[i]) {
                return false;
            }
        }

        return true;
    }

}
